import React from "react";
import styles from "./PlanExpiredCard.module.scss";
import { Grid2 } from "@mui/material";
import CustomButton from "../CustomButton/CustomButton";
import { ReactComponent as PlanExpriedIcon } from "../../GlobalAssets/svg/PlanExpriedIcon.svg";
import { formatDate } from "../../Utils/utils";
import { useNavigate, useParams } from "react-router-dom";

const PlanExpiredCard = ({ org, plan }) => {
  const navigate = useNavigate();
  const paymentDate = formatDate(plan?.expirationDate);
  const params = useParams();
  const orgId = parseInt(params.orgId);
  const handleClick = () => {
    navigate(`/account/${orgId}/modify-plan`);
  };

  const handleRenewClick = () => {
    navigate(`/account/${orgId}/modify-plan?renew=true`);
  };

  return (
    <Grid2 className={styles.PlanExpiredCardContainer}>
      <Grid2 className={styles.backGround}>
        <PlanExpriedIcon />
        <Grid2 className={styles.header}>
          {org?.parentOrgName !== null && orgId !== -1
            ? "Your primary organization's plan has expired."
            : `Oops! Your ${plan?.isSingleSite === false ? "MS" : "SS"} - ${
                plan?.licenseType
              } Plan Has Expired`}
        </Grid2>
        <Grid2 className={styles.subHeader}>
          {org?.parentOrgName !== null && orgId !== -1 ? (
            "Renew now to continue using all services without interruption."
          ) : (
            <>
              Looks like your{" "}
              <span className={styles.orgName}>
                {" "}
                {orgId !== -1 && <>{org?.name} organization</>}
              </span>{" "}
              plan expired on {paymentDate}.<br />
              No worries – renew now to pick up right where you left off!.
            </>
          )}
        </Grid2>
        {org?.parentOrgName !== null && orgId !== -1 ? (
          ""
        ) : (
          <Grid2 className={styles.buttonFlex}>
            <Grid2 className={styles.planButton} onClick={handleClick}>
              Choose your own Plan
            </Grid2>
            <CustomButton
              className={styles.planButton1}
              onClick={handleRenewClick}
            >
              Renew Now
            </CustomButton>
          </Grid2>
        )}
      </Grid2>
    </Grid2>
  );
};

export default PlanExpiredCard;
